import React from 'react';
import { makeStyles,  createStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles(() =>
  createStyles({
    subtitle: {
      textDecoration: 'underline'
    },
    annotation: {
      fontSize: '0.75rem',
      marginBottom: '5px',
    },
    bold: {
      fontWeight: 'bold',
    },
  }),
);

/** サービス概要の日本語版本文。 */
const JP: React.FC = () => {
  const classes = useStyles();
  return (
    <div>
      <h3 className={classes.subtitle}>このサービスについて</h3>
      <p>メールによるハイヤー・タクシー配車予約サービスです。ご利用空港およびご利用航空便にあわせて、地図上で選択いただいた「指定地点から空港まで」「空港から指定地点まで」のハイヤー・タクシーの配車予約が可能です。</p>
      <p className={classes.annotation}>※提携のハイヤー・タクシー会社は順次拡大してまいります。</p>
      <h3 className={classes.subtitle}>推奨環境</h3>
      {/* PC環境 */}
      <Typography className={classes.bold}>・PC</Typography>
      <Typography className={classes.bold}>Windows</Typography>
      <Typography>Google Chrome 最新版、Microsoft Edge 最新版</Typography>
      <Typography className={classes.bold}>Macintosh</Typography>
      <Typography gutterBottom>Google Chrome 最新版</Typography>
      {/* スマートフォン・タブレット環境 */}
      <Typography className={classes.bold}>・スマートフォン・タブレット</Typography>
      <Typography className={classes.bold}>iOS</Typography>
      <Typography>Safari 最新版</Typography>
      <Typography className={classes.bold}>Android</Typography>
      <Typography gutterBottom>Google Chrome 最新版</Typography>
      {/* 注釈 */}
      <Typography className={classes.annotation}>
        *推奨環境範囲内であっても、ブラウザとOSの組み合わせ等の理由により、一部表示不具合や各種機能がご利用になれない場合がございます（各種ブラウザのベータ版、プレビュー版等でのご利用、一部アドオンのご利用も含みます）。
      </Typography>
      <Typography className={classes.annotation}>
        *新しいブラウザへの対応は随時検討を進めてまいりますが、公表されていないブラウザ固有の不具合により、表示や動作の安定性が確保できていない場合がございます。
      </Typography>
      <h3 className={classes.subtitle}>所要距離および所要時間の概算表示について</h3>
      <p>地図で選択いただいた座標をもとに想定走行距離および想定所要時間を算出しております。所要時間の取得には、ハイヤー・タクシーのご乗車予定時刻を起点とした混雑予想を加味して所要時間を表示しておりますが、道路事情等により実際と異なる場合がございますのでご注意ください。</p>
      <p>※地図情報提供元：Google</p>
    </div>
  );
}

export default JP;
